import { render, staticRenderFns } from "./ApproveButton.vue?vue&type=template&id=0ec7ad1e&scoped=true&"
import script from "./ApproveButton.vue?vue&type=script&lang=js&"
export * from "./ApproveButton.vue?vue&type=script&lang=js&"
import style0 from "./ApproveButton.vue?vue&type=style&index=0&id=0ec7ad1e&scoped=true&lang=css&"
import style1 from "./ApproveButton.vue?vue&type=style&index=1&id=0ec7ad1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec7ad1e",
  null
  
)

export default component.exports